import { render, staticRenderFns } from "./BInput.vue?vue&type=template&id=6b9683aa&"
import script from "./BInput.vue?vue&type=script&lang=js&"
export * from "./BInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports